module.exports = __webpack_public_path__ + "media/recenzie2.a0aa7cc3.mp4";